// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_65-3";
export var contentContainer = "_65-0";
export var editorContainer = "_65-1";
export var quillInputForm = "_65-2";
export var zoneDivider = "_65-4";